import { Strings } from "src/app/common/utility/string/string";

export const Route = {
    Authentication: {
        PoolId: Strings.Empty,
        Policy: "policy"
    },
    User: {
        Create: 'create',
        Update: 'update',
        ToggleState: 'toggle',
        ResendPassword: 'resendPassword',
        // Sources: {
        //     Fetch: 'fetch',
        //     Set: 'set'
        // },
        EdgeDevices: {
            Fetch: 'fetch',
            Set: 'set',
        }
    },
    Users: {
        List: 'list',
    },
    Organization: {
        List: 'list',
        Information: Strings.Empty,
        Sources: {
            Fetch: 'fetch',
            Set: 'set',
        },
        EdgeDevices: {
            Fetch: 'fetch',
            Set: 'set',
        }
    },
    Logging: {
        Send: 'send'
    },
    Report: {
        EmbeddedUrl: 'url'
    },
    EdgeDevice: {
        List: 'list',
        Update: 'update'
    },
    BatteryString: {
        Fetch: 'fetch',
        Set: 'set'
    }

}
